
import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";


export const getAreas = async () => {
    
    const result = await PrivateInterceptor(`Base/Global/Areas`, 'GET');
    return result;

}

export const getAreasIPS = async() =>{
    const result = await PrivateInterceptor(`Base/Global/Areas/areasIPS`, 'GET');
    return result;
}

export const getAllAreasIPS = async() =>{
    const result = await PrivateInterceptor(`Base/Global/Areas/areasIPSALL`, 'GET');
    return result;
}

export const getAreasActivasIPS = async() =>{
    const result = await PrivateInterceptor(`Base/Global/Areas/areasIPSActivas`, 'GET');
    return result;
}

export const getArea = async(IdArea) =>{
    const result = await PrivateInterceptor(`Base/Global/Areas/${IdArea}`, 'GET');
    return result;
}

export const getMaquinasByArea = async(IdArea) =>{
    const result = await PrivateInterceptor(`Base/Global/Areas/maquinasByArea/${IdArea}`, 'GET');
    return result;
}

export const putClasificacionArea = async(datos) =>{
    const result = await PrivateInterceptor(`Base/Global/Areas/AreaIPSClasificacion`, 'PUT',{Data: datos} );
    return result;
}